
import { Prop, Vue, Component, Watch } from 'vue-property-decorator';
import { getFiledCourseList, FiledCourseSingle, cancelFiledCourse } from '@/apis/courseList/courseList';
import CommonVue from '@/components/CommonVue/CommonVue';
import i18n from '@/lang/index';

@Component
export default class FiledCourse extends CommonVue {
  private active = 'teach';
  private loading = true;

  private typeList: { name: string, value: string }[] = [];
  private filedCourseList: {
    none:FiledCourseSingle[],
    teach: FiledCourseSingle[],
    assistant: FiledCourseSingle[],
    study: FiledCourseSingle[],
  } = { none:[], teach: [], study: [], assistant: [] };

  get userInfo() {
    return this.$store.getters.getUserInfo;
  }

  mounted() {
    if(this.userInfo.usertype == '0') {
      this.active = 'study'
      this.typeList = [
        { name: i18n.t('Home.Title.我学的') as string, value: 'study' },
        { name: i18n.t('Home.Title.我协助的') as string, value: 'assistant' },
      ]
    } else {
      this.typeList = [
        { name: i18n.t('Home.Title.我教的') as string, value: 'teach' },
        { name: i18n.t('Home.Title.我协助的') as string, value: 'assistant' },
        { name: i18n.t('Home.Title.我学的') as string, value: 'study' },
      ];
    }
    this.getFiledCourseList();
  }

  getFiledCourseList() {
    this.loading = true;
    getFiledCourseList().then(res => {
      this.loading = false;
      this.filedCourseList = { none:[], teach: [], assistant: [],study: []};
      const target: ['none','teach', 'assistant','study'] = ['none','teach', 'assistant', 'study'];
      res.lists.forEach((item) => {
        if(target[item.icontype]){
            this.filedCourseList[target[item.icontype]].push(item);
        }
      });
      this.$forceUpdate();
    });
  }

  cancelFiledCourse(item: FiledCourseSingle) {
    this.$dialog.confirm({
      confirmButtonText: i18n.t('Common.恢复') as string,
      cancelButtonText: i18n.t('Common.取消') as string,
      showCancelButton: true,
      title: `${i18n.t('Home.要恢复')}'${ item.coursename }'${i18n.t('Home.吗')}`,
      message: `${i18n.t('Home.您')}${ item.role === 1 ? i18n.t('Home.和您的学生') : '' }${i18n.t('Home.可以重新在此课程中互动')}<br/>${i18n.t('Home.此课程会在课程首页上显示')}`
    }).then(() => {
      cancelFiledCourse({ courseid: item.courseid, icontype: item.icontype }).then(() => {
        this.$dialog.alert({
          title: i18n.t('Home.取消归档成功') as string
        }).then(() => {
          this.getFiledCourseList();
        });
      });
    }).catch();
  }
}
